import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  FormHelperText,
  TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { handleCancelPermit } from "../../store/actions/uiActions/myPermitsActions";

function RemovePermitPackage({
  open,
  setOpen,
  selectedPermitType,
  isAdditionalPermit,
}) {
  const { selectedRow } = useSelector((state) => state.myPermitsComponent);
  const { cancelPermitLoading } = useSelector(
    (state) => state.myPermitsComponent.permits.loadings
  );
  const dispatch = useDispatch();

  const [cancelPermitComment, setCancelPermitComment] = useState("");
  const [isRemovingAdditionalPermit, setIsRemovingAdditionalPermit] =
    useState(false);

  // Reset flag when modal closes
  useEffect(() => {
    if (!open) {
      setIsRemovingAdditionalPermit(false);
    }
  }, [open]);

  const onConfirm = async () => {
    if (isAdditionalPermit) {
      // Set flag to prevent city site comment field from showing during removal
      setIsRemovingAdditionalPermit(true);
      // Handle additional permit removal
      const result = await dispatch(
        handleCancelPermit(cancelPermitComment, selectedPermitType, true)
      );
      // Close modal after successful removal
      if (result) {
        setCancelPermitComment("");
        setOpen(false);
      }
      // Reset flag
      setIsRemovingAdditionalPermit(false);
    } else {
      // Handle main permit package removal
      const result = await dispatch(handleCancelPermit(cancelPermitComment));
      // Close modal after successful removal
      if (result) {
        setCancelPermitComment("");
        setOpen(false);
      }
    }
  };

  return (
    <Modal open={open}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          borderRadius: "10px",
          boxShadow: 24,
          p: 4,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h4"
          align="center"
          component="h2"
          color="error"
        >
          {isAdditionalPermit
            ? "Remove Additional Permit"
            : "Remove Permit Package"}
        </Typography>
        <Typography
          align="center"
          id="modal-modal-description"
          sx={{ color: "#e57373", fontWeight: "bold" }}
        >
          {isAdditionalPermit
            ? `Are you sure you want to remove the ${selectedPermitType?.replace(/_/g, " ")} permit from this package?`
            : "Are you sure you want to remove this permit package?"}
        </Typography>

        <Box sx={{ mt: 2 }}>
          {(!isAdditionalPermit &&
            selectedRow?.connect_to_city?.permit?.permit_id) ||
          (isAdditionalPermit &&
            !isRemovingAdditionalPermit &&
            selectedRow?.additional_permits?.[selectedPermitType]
              ?.connect_to_city?.is_connected) ? (
            <>
              <TextField
                variant="filled"
                multiline
                rows={4}
                value={cancelPermitComment}
                onChange={(e) => {
                  let val = e.target.value;
                  if (val.length > 100) {
                    val = val.slice(0, 100);
                  }
                  setCancelPermitComment(val);
                }}
                label="Please enter a comment about why the permit is being voided"
                fullWidth
              />
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <FormHelperText>
                  <span
                    style={{
                      color:
                        cancelPermitComment.length < 10 ? "#F04438" : "inherit",
                    }}
                  >
                    {cancelPermitComment.length}
                  </span>
                  /100
                </FormHelperText>
                {cancelPermitComment.length < 10 && (
                  <FormHelperText sx={{ color: "#F04438" }}>
                    Must be at least 10 characters
                  </FormHelperText>
                )}
              </Box>
            </>
          ) : (
            <></>
          )}
        </Box>

        <Box sx={{ mt: 5, display: "flex", justifyContent: "space-between" }}>
          <LoadingButton
            disabled={Boolean(
              cancelPermitComment.length < 10 &&
                ((!isAdditionalPermit &&
                  selectedRow?.connect_to_city?.permit?.permit_id) ||
                  (isAdditionalPermit &&
                    !isRemovingAdditionalPermit &&
                    selectedRow?.additional_permits?.[selectedPermitType]
                      ?.connect_to_city?.is_connected))
            )}
            loading={cancelPermitLoading}
            sx={{ mr: 1 }}
            fullWidth
            color="error"
            onClick={onConfirm}
          >
            Remove
          </LoadingButton>
          <Button
            disabled={Boolean(cancelPermitLoading)}
            sx={{ ml: 1 }}
            fullWidth
            variant="contained"
            color="success"
            onClick={() => {
              setCancelPermitComment("");
              setOpen(false);
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default React.memo(RemovePermitPackage);
